/***
 * An Autocomplete component that selects a Realtor Association
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import StoreAutoComplete from './StoreAutoComplete'

@observer
export default class RaAutocomplete extends Component {
  static propTypes = {
    /**
     * An RA store (Provision)
     */
    raStore: PropTypes.object.isRequired, // ideally objectOf(Provision) but doesn't work w/our babel setup presently
  }

  render() {
    const { props } = this

    return <StoreAutoComplete
      placeholder="Add a Realtor Association"
      getValue={props.raStore.autocompleteLabelGenerator}
      {...props}
      store={props.raStore}
      />
  }
}



// WEBPACK FOOTER //
// client/components/util/auto_complete/RaAutocomplete.js